var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgErrorAlert = function SvgErrorAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15 22a7 7 0 110-14 7 7 0 010 14zm1.044-7l1.74-1.74a.738.738 0 10-1.044-1.044L15 13.956l-1.74-1.74a.738.738 0 00-1.044 1.044l1.74 1.74-1.74 1.74a.738.738 0 001.044 1.044l1.74-1.74 1.74 1.74a.738.738 0 101.044-1.044L16.044 15z"
  })));
};
export default SvgErrorAlert;